module.exports = __webpack_public_path__ + "img/icon-dropdown-light-white.7d529227.svg";